import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import TaskIcon from '@material-ui/icons/Done'
import ViewModuleIcon from '@material-ui/icons/ViewModule'
import RemoveRedEye from '@material-ui/icons/RemoveRedEye'
import { clickBottomNavigation } from 'actions/tasks'
import styles from 'components/TemplateForm/styles'

class BottomNav extends Component {
	componentDidMount() {
		this.props.clickBottomNavigation(0)
	}

	componentWillUnmount() {
		this.props.clickBottomNavigation(0)
	}

	render() {
		const {
			clickBottomNavigation,
			bottomNavigation,
			classes,
			selectedActionPrediction,
			disabled,
		} = this.props

		if (
			selectedActionPrediction === 'email' ||
			selectedActionPrediction === 'sms'
		) {
			return (
				<BottomNavigation
					style={{ position: 'relative' }}
					className={classes.bottomNav}
					onChange={(e, val) => {
						e.stopPropagation()
						clickBottomNavigation(val)
					}}
					value={bottomNavigation}
					showLabels
				>
					<BottomNavigationAction
						classes={{
							selected: classes.bottomNavActionSelected,
							label: classes.bottomNavLabel,
						}}
						label="Preview"
						icon={<RemoveRedEye style={{ color: '#fff' }} />}
					/>
					<BottomNavigationAction
						classes={{
							selected: classes.bottomNavActionSelected,
							label: classes.bottomNavLabel,
						}}
						label="Task Info"
						icon={<TaskIcon style={{ color: '#fff' }} />}
					/>
					{selectedActionPrediction === 'email' && !disabled && (
						<BottomNavigationAction
							classes={{
								selected: classes.bottomNavActionSelected,
								label: classes.bottomNavLabel,
							}}
							label="Snippets"
							icon={<ViewModuleIcon style={{ color: '#fff' }} />}
						/>
					)}
				</BottomNavigation>
			)
		}

		return null
	}
}

export default connect(
	(state) => {
		const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
		const stats = task?.sms_stats || task?.email_stats
		const campaignStatus =
			state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
		const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
		const disabled = Boolean(
			(stats && automationTypeSelected !== 'stage') ||
				campaignStatus === 'L' ||
				campaignStatus === 'C',
		)

		return {
			bottomNavigation: state.tasks.addOrEdit.bottomNavigation.index,
			selectedActionPrediction:
				state.tasks.addOrEdit.fields.selectedActionPrediction.value,
			disabled,
		}
	},
	(dispatch) => bindActionCreators({ clickBottomNavigation }, dispatch),
)(withStyles(styles)(BottomNav))
